import React from "react";
import { useNavigate } from "react-router-dom";
import {
     MainLeftTitle,
     CreateButton,
} from "../../../_uiComponents/WrapperComponents";
import { SearchBarWr } from "../../../_uiComponents/common/form/UiInputComponents";
import FactTableFilterForm from "./forms/FactTableFilterForm";
import FactTableManagement from "./FactTableManagement";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";
import { UiFullLoadingSpinner } from "../../../_uiComponents/common/UiLoadingSpinner";


function FactTableWrapper() {
    const navigate = useNavigate();
    const handleData = () => {
        let path = `/ui/create-lookup-table`;
        navigate(path);
    }

     return (
          <>
           <UiFullLoadingSpinner loader={true}/>
          <div className="sbt-data-grid__wr">
               <MainLeftTitle title="Fact Table Management">
                    <CreateButton name="Create Fact Table" onClick={handleData} />
               </MainLeftTitle>
                    <UiAccordian>
                         <SearchBarWr>
                              <FactTableFilterForm/>
                         </SearchBarWr>
                    </UiAccordian>
               <FactTableManagement />
          </div>
          </>
     );
}

export default FactTableWrapper;